import { useEffect } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { LoginComponent } from '../components/Auth/LoginComponent';
import { useAuth } from '../contexts/AuthContext';
import { useUser } from '../contexts/UserContext';
import { LoadingTimeout } from '../components/ui/LoadingTimeout';

interface LocationState {
  from?: { pathname: string };
  signupSuccess?: boolean;
  message?: string;
}

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, loading } = useAuth();
  useUser();
  
  // Get the location state
  const state = location.state as LocationState;
  const from = state?.from?.pathname || '/';
  const signupSuccess = state?.signupSuccess || false;
  const successMessage = state?.message || '';
  
  // Naviger når autentisert og auth.loading er ferdig (ikke vent på UserContext)
  useEffect(() => {
    const state = { loading, isAuthenticated, from };
    if (!loading && isAuthenticated) {
      console.log('[Login → navigate]', state);
      navigate(from, { replace: true });
    } else {
      console.log('[Login wait]', state);
    }
  }, [loading, isAuthenticated, navigate, from]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
        <LoadingTimeout isLoading={loading} variant="light" loadingText="Laster..." />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 bg-white p-8 rounded-xl shadow-md">
        <div>
          <img 
            src="/images/Condo-logo-dark.png" 
            alt="Condo" 
            className="h-12 mx-auto"
          />
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Logg inn på din konto
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Få tilgang til din bolig og bofellesskap
          </p>
        </div>
        
        {/* Success message after signup */}
        {signupSuccess && (
          <div className="bg-green-50 border border-green-200 rounded-md p-3">
            <p className="text-sm text-green-700">{successMessage}</p>
          </div>
        )}
        
        <div className="mt-8">
          <LoginComponent onSuccess={() => { /* Navigasjon håndteres av effekt når membership er klart */ }} />
        </div>
        
        {/* Sign up link */}
        <div className="mt-4 text-center">
          <p className="text-sm text-gray-600">
            Har du ikke en konto?{' '}
            <Link to="/signup" className="font-medium text-condo-dark hover:text-condo-med">
              Opprett bruker
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}